import React from "react";

const CPP_OOP = () => {
  return (
    <div>
      <h1>CPP_OOP Component</h1>
      <p>Content for CPP_OOP goes here...</p>
    </div>
  );
};

export default CPP_OOP;
